
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
export default {
  components: { InnerPageTitle },
  data() {
    return {
      alertBox: {
        status: false,
        variant: '',
        message: '',
      },
      loading: false,
      form: {
        email: '',
      },
    }
  },
  methods: {
    async SEND_EMAIL(e) {
      e.preventDefault()
      this.alertBox.status = false
      this.loading = true
      const response = await this.$api.post('Users/ResetPassMail', this.form)
      if (response.message === 'OK') {
        this.alertBox = {
          status: true,
          variant: 'success',
          message: this.$custom$t('valid.successResetMail'),
        }
      } else if (response.message === 'NOTFOUND') {
        this.alertBox = {
          status: true,
          variant: 'danger',
          message: this.$custom$t('valid.mailNotFound'),
        }
      } else
        this.alertBox = {
          status: true,
          variant: 'danger',
          message: this.$custom$t('valid.errorResetMail'),
        }
      this.loading = false
    },
  },
}
